var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplineCurve20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 558",
    d: "M18.6075 2.5H5.65716C3.52518 2.5 1.79688 4.22831 1.79688 6.36029V6.36029C1.79688 8.49227 3.52519 10.2206 5.65717 10.2206H14.9678C16.9779 10.2206 18.6075 11.8501 18.6075 13.8603V13.8603C18.6075 15.8704 16.9779 17.5 14.9678 17.5H1.79688",
    stroke: "#00C2FF",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1213",
    x: 15.625,
    y: 0.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1215",
    x: 0.625,
    y: 15.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplineCurve20);
export default __webpack_public_path__ + "static/media/spline-curve_20.094cc065219b791f86ad29e6d9fcf473.svg";
export { ForwardRef as ReactComponent };